import _ from "lodash";
import React from "react";
import classes from "./ScreenBaseComponent.scss";
import classNames from "classnames";

const RIGHT_PANE_ANIMATION_TIME = 300;

class ScreenBaseComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentRightPane: "",
      rightPaneId: "",
      showRightPane: undefined,
      isFullScreenLE: false,
    };
  }

  isFullScreenRightPane = () => {
    return false;
  };

  handleRightPane = ({ rightPane, id, helperTextId, fieldKey, ...rest }) => {
    const { currentRightPane, rightPaneId } = this.state;
    if (rightPaneId == id && rightPane == currentRightPane) {
      this.updateShowRightPane(false);
      setTimeout(() => {
        this.updateRightPaneState({
          currentRightPane: "",
          rightPaneId: "",
          helperTextId: "",
          fieldKey: "",
          ...rest,
        });
      }, RIGHT_PANE_ANIMATION_TIME);
      return;
    }
    if (currentRightPane) {
      this.updateShowRightPane(false);
      setTimeout(() => {
        if (rightPane) {
          this.updateShowRightPane(true);
        }
        this.updateRightPaneState({
          currentRightPane: rightPane,
          rightPaneId: id,
          helperTextId,
          fieldKey,
          ...rest,
        });
      }, RIGHT_PANE_ANIMATION_TIME + 30);
    } else {
      this.updateShowRightPane(!!rightPane);
      if (!rightPane) {
        setTimeout(() => {
          this.updateRightPaneState({
            currentRightPane: "",
            rightPaneId: "",
            helperTextId: "",
            fieldKey: "",
            ...rest,
          });
        }, RIGHT_PANE_ANIMATION_TIME);
      } else {
        this.updateRightPaneState({
          currentRightPane: rightPane,
          rightPaneId: id,
          helperTextId,
          fieldKey,
          ...rest,
        });
      }
    }
  };

  customRightPaneScrollRef = ref => {
    this.rightPaneScroll = ref;
  };
  updateShowRightPane = val => {
    this.setState({ showRightPane: val });
    if (val && this.rightPaneScroll) {
      this.rightPaneScroll.goToScrollTop();
    }
  };
  updateRightPaneState = obj => {
    this.setState({ ...obj });
  };

  closeRightPane = () => {
    this.handleRightPane({ rightPane: "" });
    this.setState({ isFullScreenLE: false });
  };

  renderMiddlePane = () => {
    return null;
  };

  getRightPaneComponent = () => {
    return null;
  };

  showRightPaneLine = () => {
    return true;
  };

  renderRightPane = () => {
    const isFullScreenRightPane = this.isFullScreenRightPane();
    const { currentRightPane, showRightPane } = this.state;
    const {
      rightPaneWidth,
      alwaysShowRightPane,
      rightPaneLineStyle,
      customRightPaneStyle = {},
      shouldCloseOnOverlayClick = false,
      rightPaneOverlayStyle = {},
    } = this.props;

    const rightPaneStyle = classNames(
      { [classes.rightPane]: true },
      { [classes.rightPaneFullScreen]: isFullScreenRightPane },
      {
        [classes.visible]:
          (showRightPane && showRightPane != undefined) || alwaysShowRightPane,
      },
      {
        [classes.hidden]:
          !showRightPane && showRightPane != undefined && alwaysShowRightPane,
      }
    );

    const rightPane = this.getRightPaneComponent();

    const inlineRightPanStyles = !_.isNil(rightPane)
      ? {
          ...customRightPaneStyle,
          width: rightPaneWidth,
          right: -rightPaneWidth,
        }
      : { width: 0, height: 0, margin: 0, padding: 0 };

    return (
      <React.Fragment>
        {showRightPane && !!isFullScreenRightPane && (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <div
            className={classes.fullScreenOverlay}
            onClick={
              shouldCloseOnOverlayClick ? this.closeRightPane : undefined
            }
            style={rightPaneOverlayStyle}
          />
        )}
        <div className={rightPaneStyle} style={inlineRightPanStyles}>
          {!!currentRightPane && this.showRightPaneLine() && (
            <div className={classes.rightPaneLine} style={rightPaneLineStyle} />
          )}
          {rightPane}
        </div>
      </React.Fragment>
    );
  };
}

export default ScreenBaseComponent;

ScreenBaseComponent.defaultProps = {
  rightPaneWidth: 440,
  alwaysShowRightPane: false,
};
